export enum UserStatus {
  unknown = 'unknown',
  invitationSent = 'invitation_sent',
  passwordReset = 'password_reset',
  active = 'active',
  disabled = 'disabled',
  missingFromCognito = 'missing_from_cognito',
  lockedOut = 'locked_out',
}
